import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function MarketingNav() {
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  const isActive = (p) => loc.pathname === p || (p.startsWith("/#") && loc.pathname === "/");

  const link = (p, label, testid) => (
    <Link
      to={p}
      data-testid={testid}
      onClick={() => setOpen(false)}
      className={`px-3 py-2 rounded-lg text-[14px] transition-colors ${
        isActive(p)
          ? "text-[var(--aw-ink)] font-medium"
          : "text-[var(--aw-ink-2)] hover:bg-[var(--aw-surface-2)] hover:text-[var(--aw-ink)]"
      }`}
      style={{ fontFamily: "var(--font-body)" }}
    >
      {label}
    </Link>
  );

  return (
    <header className="glass-header" data-testid="marketing-nav">
      <div className="max-w-[1180px] mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="marketing-logo">
          <span className="brand-mark">A</span>
          <span
            style={{
              fontSize: 16,
              fontWeight: 600,
              letterSpacing: "-0.01em",
              fontFamily: "var(--font-body)",
            }}
          >
            AnswerWatch
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {link("/#features", "Product", "nav-product")}
          {link("/atlas", "Free Atlas", "nav-atlas")}
          {link("/pricing", "Pricing", "nav-pricing")}
          {link("/#how", "How it works", "nav-how")}
          {link("/#faq", "FAQ", "nav-faq")}
        </nav>

        {/* Desktop actions */}
        <div className="hidden lg:flex items-center gap-2">
          <Link
            to="/login"
            data-testid="nav-login"
            className="btn-aw btn-aw-ghost btn-aw-sm"
          >
            Sign in
          </Link>
          <Link
            to="/login"
            data-testid="nav-start"
            className="btn-aw btn-aw-primary btn-aw-sm"
          >
            Open app <span className="arrow">→</span>
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          aria-expanded={open}
          data-testid="nav-mobile-toggle"
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 -mr-2 text-[var(--aw-ink-2)] hover:text-[var(--aw-ink)]"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div
          className="lg:hidden border-t"
          style={{
            borderColor: "var(--aw-border)",
            background: "var(--aw-surface)",
          }}
          data-testid="nav-mobile-drawer"
        >
          <nav className="px-5 py-4 flex flex-col gap-2">
            {link("/#features", "Product", "nav-mobile-product")}
            {link("/atlas", "Free Atlas", "nav-mobile-atlas")}
            {link("/pricing", "Pricing", "nav-mobile-pricing")}
            {link("/#how", "How it works", "nav-mobile-how")}
            {link("/#faq", "FAQ", "nav-mobile-faq")}
            <div
              className="border-t pt-3 mt-2 flex items-center gap-3"
              style={{ borderColor: "var(--aw-border)" }}
            >
              <Link
                to="/login"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-login"
                className="btn-aw btn-aw-ghost btn-aw-sm"
              >
                Sign in
              </Link>
              <Link
                to="/login"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-start"
                className="btn-aw btn-aw-primary btn-aw-sm ml-auto"
              >
                Open app <span className="arrow">→</span>
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
